export default __webpack_public_path__ + "static/media/crystallizedchaos.fb9fd8f2.png";